import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { type LicensePlateColor, LicensePlateComponent } from './license-plate.component';

@Component({
  selector: 'cdf-country-license-plate',
  imports: [LicensePlateComponent],
  styleUrl: './country-license-plate.container.scss',
  template: `
    <cdf-license-plate
      [licensePlate]="licensePlate()"
      [euro]="euro()"
      [rightEuro]="rightEuro()"
      [color]="color()"
      [canEdit]="canEdit()"
      (editLicensePlate)="editLicensePlate.emit()"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountryLicensePlateContainer {
  readonly licensePlate = input.required<string | undefined>();
  readonly country = input.required<string | undefined>();
  readonly canEdit = input(false, { transform: booleanAttribute });

  readonly editLicensePlate = output<void>();

  // List of countries with a blue euro band on the left side of the license plate
  static readonly euroCountries =
    'AL,AT,BE,BA,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,MD,ME,NL,MK,NO,PL,PT,RO,RS,SK,SI,ES,SE,UA,GE,TR,XK,IR,IL,LB'.split(
      ',',
    );

  // List of countries with a blue euro band on the right side of the license plate
  static readonly rightEuroCountries = ['AL', 'FR', 'IT'];

  // List of license plate colors and their corresponding countries
  static readonly colors: Record<LicensePlateColor, string[]> = {
    yellow: ['LU', 'NL', 'GB', 'IL'],
    black: ['LI'],
    burgundy: ['BE'],
    blue: ['IS', 'MC', 'SM'],
  };

  readonly euro = computed(() => CountryLicensePlateContainer.euroCountries.includes(this.country() ?? ''));
  readonly rightEuro = computed(() => CountryLicensePlateContainer.rightEuroCountries.includes(this.country() ?? ''));
  readonly color = computed((): LicensePlateColor | undefined => {
    const country = this.country() ?? '';
    if (country) {
      for (const [color, countries] of Object.entries(CountryLicensePlateContainer.colors)) {
        if (countries.includes(country)) {
          return color as LicensePlateColor;
        }
      }
    }
    return undefined;
  });
}
